import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Accordion from "../Shared/Accordion";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { actionAppToggleComponent } from "../App";
import { actionMapPrintUpdated } from "../Map";
import {
  actionPrintExpandToggled,
  actionPrintOrientationUpdated,
  actionPrintSizeUpdated,
} from "./PrintRedux";
import { trackEvent } from "../../tracking";

const root_ = (theme) => ({
  marginTop: "10px",
});

const formControl_ = (theme) => ({
  minWidth: 120,
  marginRight: "6px",
  "& .MuiSelect-root.MuiSelect-select": {
    padding: "14.5px 14px",
  },
  "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
    transform: "translate(14px, -12px) scale(0.75)",
  },
});

const printBtn_ = (theme) => ({
  position: "absolute",
  right: 0,
  marginTop: "10px",
  marginRight: "30px",
});

export default function Print() {
  const component = "printVisible";

  const dispatch = useDispatch();

  const visible = useSelector((state) => state.appReducer[component]);
  const visibleHandler = () => {
    dispatch(actionAppToggleComponent({ component }));
  };

  const expand = useSelector((state) => state.printReducer.isExpanded);
  const expandHandler = () => {
    dispatch(actionPrintExpandToggled());
  };

  const size = useSelector((state) => state.printReducer.printSize);
  const orientation = useSelector(
    (state) => state.printReducer.printOrientation,
  );

  const handleSizeChange = (event) => {
    dispatch(actionPrintSizeUpdated(event.target.value));
  };

  const handleOrientationChange = (event) => {
    dispatch(actionPrintOrientationUpdated(event.target.value));
  };

  const printHandler = () => {
    dispatch(actionMapPrintUpdated({ status: "print", size, orientation }));
  };

  useEffect(() => {
    if (visible && expand) {
      trackEvent({
        category: "Map Generation",
        action: "Print",
      });
    }
  }, [visible, expand]);

  useEffect(() => {
    const status = visible ? "preview" : "cancel";
    dispatch(actionMapPrintUpdated({ status, size, orientation }));
  }, [dispatch, size, orientation, visible]);

  const sizeLabel = "Size";
  const orientationLabel = "Orientation";
  return (
    <Accordion
      title="Print"
      visible={visible}
      visibleHandler={visibleHandler}
      expand={expand}
      expandHandler={expandHandler}
    >
      <Grid container sx={root_}>
        <Grid size={{ xs: 12 }}>
          <FormControl variant="outlined" sx={formControl_}>
            <InputLabel id="print-size" data-testid="print-size-label">
              {sizeLabel}
            </InputLabel>
            <Select
              variant="outlined"
              labelId="print-size"
              label={sizeLabel}
              value={size}
              onChange={handleSizeChange}
              data-testid="print-size-input"
            >
              <MenuItem value="letter" data-testid="print-size-input-letter">
                Letter
              </MenuItem>
              <MenuItem value="legal" data-testid="print-size-input-legal">
                Legal
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="outlined" sx={formControl_}>
            <InputLabel
              id="print-orientation"
              data-testid="print-orientation-label"
            >
              {orientationLabel}
            </InputLabel>
            <Select
              variant="outlined"
              labelId="print-orientation"
              label={orientationLabel}
              value={orientation}
              onChange={handleOrientationChange}
            >
              <MenuItem value="landscape">Landscape</MenuItem>
              <MenuItem value="portrait">Portrait</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={printHandler}
            disabled={!size}
            sx={printBtn_}
          >
            Print
          </Button>
        </Grid>
      </Grid>
    </Accordion>
  );
}
